(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/krokodil/views/index.js') >= 0) return;  svs.modules.push('/widgets/krokodil/views/index.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widget=_svs.widget||{};
_svs.widget.krokodil=_svs.widget.krokodil||{};
_svs.widget.krokodil.templates=_svs.widget.krokodil.templates||{};
svs.widget.krokodil.templates.index = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["components-tur-products-products"],depth0,{"name":"components-tur-products-products","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["with"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.currentWidget : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['widget-krokodil-index'] = svs.widget.krokodil.templates.index;
})(svs, Handlebars);

 })(window);